import i from "../utils.js";
function o(r) {
  return i.isObject(r) && r.isAxiosError === !0;
}
export {
  o as default
};
